<template>
  <div :class="[isMobileLayout ? 'ml-16' : '']">
    <el-collapse :accordion="false" :value="'blogThemes'">
      <el-collapse-item name="blogThemes" class="d-none">
        <template slot="title">
          <div class="subtitle1">
            {{ blogThemeLabel }}
          </div>
        </template>
        <el-tree
          ref="blogThemeTree"
          class="mb-10"
          node-key="id"
          :empty-text="'empty.text'"
          :data="blogThemeTreeData"
          :props="blogThemeTreeProps"
          :class="'tree_layout'"
          default-expand-all
          :default-checked-keys="blogThemeTreeDefaultCheckedKeys"
          highlight-current
          show-checkbox
          @check-change="handleCheckChange"
        />
      </el-collapse-item>

      <el-collapse-item name="blogTypes">
        <template slot="title">
          <div class="subtitle1">
            {{ typeOfBlogLabel }}
          </div>
        </template>
        <el-tree
          ref="blogTypeTree"
          class="mb-10"
          node-key="id"
          :empty-text="'empty.text'"
          :data="blogTypeTreeData"
          :props="blogTypeTreeProps"
          :class="'tree_layout'"
          default-expand-all
          :default-checked-keys="blogTypeTreeDefaultCheckedKeys"
          highlight-current
          show-checkbox
          @check-change="handleCheckChange"
        />
      </el-collapse-item>

      <!-- <el-collapse-item name="blogAuthors">
        <template slot="title">
          <div class="subtitle1">
            {{ blogAuthorLabel }}
          </div>
        </template>
        <Scrollable>
          <el-tree
            ref="blogAuthorTree"
            class="mb-10"
            node-key="id"
            :empty-text="'empty.text'"
            :data="blogAuthorTreeData"
            :props="blogAuthorTreeProps"
            :class="'tree_layout'"
            default-expand-all
            :default-checked-keys="blogAuthorTreeDefaultCheckedKeys"
            highlight-current
            show-checkbox
            @check-change="handleCheckChange"
          />
        </Scrollable>
      </el-collapse-item> -->
      <!-- <el-collapse-item name="country" class="product-availibility-tree">
        <template slot="title">
          <div class="subtitle1">
            {{ countryRegionLabel }}
          </div>
        </template>

        <Scrollable
          id="tree-root"
          class="tree__root product_filter ml"
          :horizontal="false"
        >
          <el-tree
            ref="countryRegionTree"
            node-key="id"
            class="mb-10"
            :empty-text="'empty.text'"
            :data="regionTreeData"
            :props="regionTreeProps"
            :class="'tree_layout'"
            :default-checked-keys="countryRegionTreeDefaultCheckedKeys"
            highlight-current
            show-checkbox
            @check-change="handleCheckChange"
          />
        </Scrollable>

        <el-divider />
      </el-collapse-item> -->
    </el-collapse>
  </div>
</template>

<script>
import { find, forEach, isEmpty } from "@/utils/lodash";

import layoutUtils from "@/utils/layout-utils";
// import Scrollable from "@/components/scrollable.vue";

export default {
  components: {
    // Scrollable,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({
        types: [],
        themes: [],
        // authors: [],
        // countries: [],
        // regions: [],
      }),
    },
    blogTypesModel: {
      type: Array,
      default: () => [],
    },
    themesModel: {
      type: Array,
      default: () => [],
    },
    // authorsModel: {
    //   type: Array,
    //   default: () => [],
    // },
    // countriesModel: {
    //   type: Array,
    //   default: () => [],
    // },
    // regionsModel: {
    //   type: Array,
    //   default: () => [],
    // },
    filterReset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortSelectedValue: "",
      clonedTypesModel: this.blogTypesModel,
      clonedThemesModel: this.themesModel,
      // clonedAuthorsModel: this.authorsModel,
      // clonedCountriesModel: this.countriesModel,
      // clonedRegionsModel: this.regionsModel,

      modelName: {
        type: "type",
        theme: "theme",
        // author: "author",
        // country: "country",
        // region: "region",
      },

      blogTypeTreeDefaultCheckedKeys: [],
      blogTypeTreeProps: {
        label: "name",
      },
      blogThemeTreeDefaultCheckedKeys: [],
      blogThemeTreeProps: {
        label: "value",
      },
      // blogAuthorTreeDefaultCheckedKeys: [],
      // blogAuthorTreeProps: {
      //   label: "value",
      // },
      // regionTreeProps: {
      //   label: "name",
      //   children: "regions",
      //   disabled: (data) => {
      //     const regions = get(data, "regions");
      //     return regions && regions.length === 0;
      //   },
      // },
      // countryRegionTreeDefaultCheckedKeys: [],
    };
  },
  computed: {
    typeOfBlogLabel() {
      return this.$i18n.t("blogs.filters.label.headers.typeOfBlog");
    },
    blogThemeLabel() {
      return this.$i18n.t("blogs.filters.label.headers.themes");
    },
    // blogAuthorLabel() {
    //   return this.$i18n.t("blogs.filters.label.headers.authors");
    // },
    isFilterReset() {
      return this.filterReset;
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    // countryRegionLabel() {
    //   return this.$i18n.t("products.filters.label.headers.countryRegion");
    // },
    // regionTreeData() {
    //   const rootElement = {
    //     id: 0,
    //     name: this.$i18n.t("products.filters.label.all"),
    //     category: this.modelName.region,
    //   };

    //   if (
    //     this.filters &&
    //     this.filters.countries &&
    //     this.filters.countries.length != 0
    //   ) {
    //     const clonedCountries = cloneDeep(this.filters.countries);
    //     clonedCountries.sort(function (a, b) {
    //       return a.name === b.name ? 0 : a.name < b.name ? -1 : 1;
    //     });
    //     forEach(clonedCountries, (country) => {
    //       country.name += ` (${country.regions.length})`;
    //       country.originalId = country.id;
    //       country.id = country.code;
    //       country.category = this.modelName.country;
    //       country.parent = rootElement;
    //       if (!isEmpty(country.regions)) {
    //         forEach(country.regions, (region) => {
    //           region.originalId = region.id;
    //           region.category = this.modelName.region;
    //           region.parent = country;
    //         });
    //       }
    //     });

    //     return [rootElement, ...clonedCountries];
    //   }

    //   return [rootElement];
    // },
    blogTypeTreeData() {
      const rootElement = {
        id: 0,
        name: this.$i18n.t("blogs.filters.label.all"),
        category: this.modelName.type,
      };

      if (this.filters && this.filters.types) {
        return [rootElement, ...this.filters.types];
      }

      return [rootElement];
    },
    blogThemeTreeData() {
      const rootElement = {
        id: 0,
        value: this.$i18n.t("blogs.filters.label.all"),
        category: this.modelName.theme,
      };

      if (this.filters && this.filters.themes) {
        return [rootElement, ...this.filters.themes];
      }

      return [rootElement];
    },
    blogAuthorTreeData() {
      const rootElement = {
        id: 0,
        value: this.$i18n.t("blogs.filters.label.all"),
        category: this.modelName.author,
      };

      if (this.filters && this.filters.authors) {
        return [rootElement, ...this.filters.authors];
      }

      return [rootElement];
    },
    isBlogThemesReady() {
      return !isEmpty(this.filters.themes);
    },
  },
  watch: {
    clonedTypesModel() {
      this.triggerFilterChange();
    },
    clonedThemesModel() {
      this.triggerFilterChange();
    },
    // clonedAuthorsModel() {
    //   this.triggerFilterChange();
    // },
    // clonedCountriesModel(newVal, oldVal) {
    //   if (newVal.length != oldVal.length) {
    //     this.triggerFilterChange();
    //   }
    // },
    // clonedRegionsModel(newVal, oldVal) {
    //   if (newVal.length != oldVal.length) {
    //     this.triggerFilterChange();
    //   }
    // },
    isFilterReset() {
      if (this.filterReset) {
        this.$refs.blogTypeTree.setCheckedKeys([]);
        this.$refs.blogThemeTree.setCheckedKeys([]);
        // this.$refs.blogAuthorTree.setCheckedKeys([]);
        // this.$refs.countryRegionTree.setCheckedKeys([]);
        this.$emit("filter-reset");
      }
    },
    isBlogThemesReady() {
      this.initTreeDefaultCheckedKeys();
    },
  },
  mounted() {
    this.initTreeDefaultCheckedKeys();
    this.blogTypeTreeDefaultCheckedKeys =
      this.$route.query.type == "PROCUCER" ? [1] : [];
    this.blogTypeTreeDefaultCheckedKeys =
      this.$route.query.type == "VIDEO" ? [2] : [];
  },
  methods: {
    triggerFilterChange() {
      this.setFiltersToQuery();
      this.emitFilterChange();
    },
    setFiltersToQuery() {
      // this.$router
      //   .push({
      //     query: {
      //       ...this.$route.query,
      //       type: this.clonedTypesModel,
      //   a: this.clonedThemesModel,
      //   u: this.clonedAuthorsModel,
      //   c: this.clonedCountriesModel,
      //   r: this.clonedRegionsModel,
      //     },
      //   })
      //   .catch(() => {});
      const initQuery = {
        ...this.$route.query,
        type: this.clonedTypesModel,
        // a: this.clonedThemesModel,
        u: this.clonedAuthorsModel,
        // c: this.clonedCountriesModel,
        // r: this.clonedRegionsModel,
      };

      const query = {};

      forEach(initQuery, (value, key) => {
        if (value != null) {
          query[key] = value;
        }
      });

      this.$router
        .push({
          query,
        })
        .catch(() => {});
    },
    emitFilterChange() {
      this.$emit("filter-change", {
        types: this.clonedTypesModel,
        themes: this.clonedThemesModel,
        // authors: this.clonedAuthorsModel,
        // countries: this.clonedCountriesModel,
        // regions: this.clonedRegionsModel,
      });
    },
    updateFilters() {
      const typesModel = [];
      const themesModel = [];
      // const authorsModel = [];
      // const regionsModel = [];

      this.updateFilterElements(this.$refs.blogTypeTree, typesModel);
      this.updateFilterElements(this.$refs.blogThemeTree, themesModel);
      // this.updateFilterElements(this.$refs.blogAuthorTree, authorsModel);
      
      // if (this.$refs.countryRegionTree.getCheckedNodes().length > 1) {
      //   this.$refs.countryRegionTree.setChecked(0, false);
      // } else if (this.$refs.countryRegionTree.getCheckedNodes().length === 0) {
      //   this.$refs.countryRegionTree.setChecked(0, true);
      // }

      // forEach(this.$refs.countryRegionTree.getCheckedNodes(), (node) => {
      //   if (
      //     node &&
      //     node.id !== 0 &&
      //     node.category === this.modelName.region &&
      //     regionsModel.findIndex((code) => code === node.id) === -1
      //   ) {
      //     regionsModel.push(node.id);
      //   }
      // });

      this.clonedTypesModel = typesModel;
      this.clonedThemesModel = themesModel;
      // this.clonedAuthorsModel = authorsModel;
      // this.clonedRegionsModel = regionsModel;
    },
    updateFilterElements(tree, model) {
      if (tree.getCheckedNodes().length > 1) {
        tree.setChecked(0, false);
      } else if (tree.getCheckedNodes().length === 0) {
        tree.setChecked(0, true);
      }

      forEach(tree.getCheckedNodes(), (node) => {
        if (
          node &&
          node.id !== 0 &&
          model.findIndex((code) => code === node.code) === -1
        ) {
          model.push(node.code);
        }
      });
    },
    handleCheckChange(data) {
      const allLabel = this.$i18n.t("blogs.filters.label.all");
      if (data.name === allLabel || data.value === allLabel) {
        switch (data.category) {
          case this.modelName.type:
            this.resetTreeCheckboxes(this.$refs.blogTypeTree);
            break;
          case this.modelName.theme:
            this.resetTreeCheckboxes(this.$refs.blogThemeTree);
            break;
          // case this.modelName.author:
          //   this.resetTreeCheckboxes(this.$refs.blogAuthorTree);
          //   break;
          // case this.modelName.region:
          // this.resetTreeCheckboxes(this.$refs.countryRegionTree);
          //   break;
          default:
            break;
        }
      } else {
        this.updateFilters();
      }
    },
    resetTreeCheckboxes(tree) {
      const checkedKeys = tree.getCheckedKeys();
      if (
        (isEmpty(checkedKeys) && tree.data != null) ||
        find(checkedKeys, (key) => key === 0) != null
      ) {
        tree.setCheckedKeys([0]);
      }
    },
    initTreeDefaultCheckedKeys() {
      this.blogTypeTreeDefaultCheckedKeys = this.getDefaultSelectedIdentifiers(
        this.clonedTypesModel,
        this.filters.types
      );
      this.blogThemeTreeDefaultCheckedKeys = this.getDefaultSelectedIdentifiers(
        this.clonedThemesModel,
        this.filters.themes
      );
      // this.blogAuthorTreeDefaultCheckedKeys =
      //   this.getDefaultSelectedIdentifiers(
      //     this.clonedAuthorsModel,
      //     this.filters.authors
      //   );
      //   const defaultSelectedIdentifiers = [];
      //   if (isEmpty(this.clonedRegionsModel)) {
      //   defaultSelectedIdentifiers.push(0);
      // } else {
      //   forEach(this.clonedRegionsModel, (regionId) => {
      //     defaultSelectedIdentifiers.push(regionId);
      //   });
      // }
      // this.countryRegionTreeDefaultCheckedKeys = defaultSelectedIdentifiers;
    },
    getDefaultSelectedIdentifiers(model, filters) {
      const defaultSelectedIdentifiers = [];

      if (isEmpty(model)) {
        defaultSelectedIdentifiers.push(0);
      } else {
        forEach(model, (code) => {
          const foundElement = find(
            filters,
            (filterElement) => filterElement.code === code
          );
          if (foundElement != null) {
            defaultSelectedIdentifiers.push(foundElement.id);
          }
        });
      }

      return defaultSelectedIdentifiers;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.el-tree {
  .el-tree-node__label {
    color: #272421 !important;
  }
  & span {
    font-family: $font-family-bold-book;
    font-weight: $font-weight-bold-book;

    @media screen and (min-width: $media-sm) {
      font-size: 13px;
      letter-spacing: 0.25px;
    }

    @media screen and (max-width: $media-sm) {
      font-size: 13px;
      letter-spacing: 0.25px;
    }
  }
}
.el-checkbox__input.is-checked {
  & .el-checkbox__inner {
    background-color: $color-primary !important;
    border-color: $color-primary !important;
  }
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: $color-primary !important;
  border-color: $color-primary !important;
}
.el-drawer__header {
  text-align: left;
  margin-bottom: 12px !important;
  padding-left: 16px !important;
  font-family: $font-family-bold;
  font-weight: $font-weight-bold;
  color: #333333 !important;
  font-size: 18px !important;
}
.tree__root {
  height: 750px;
}
.tree_layout {
  margin-left: 0 !important;
  width: 150%;
}
.el-icon-caret-right {
  position: absolute;
  left: 164px;
}
</style>
